<template>
  <div class="flex-center">
    <core-tooltip text="Background fill">
      <u-button @click="openFillPanel" variant="ghost" color="charcoal" class="dark:text-white">
        <template #leading>
          <div class="rounded-full w-5 h-5 shadow" :style="fillStyle" />
        </template>
        Background
      </u-button>
    </core-tooltip>
  </div>
</template>

<script setup>
  import {storeToRefs} from 'pinia';

  const surfaceEditorStore = useSurfaceEditorStore();
  const surfaceEditorUtils = useSurfaceEditorUtils();

  const {selectedElement} = storeToRefs(surfaceEditorStore);
  const content = computed(() => selectedElement.value?.content);
  const fillStyle = computed(() => surfaceEditorUtils.fillToStyle({fill: content.value.fill}));

  function openFillPanel() {
    surfaceEditorStore.openContextualPanel({
      id: 'color',
      props: {
        current: computed(() => content.value?.fill),
        onSelect: setFill,
        mode: selectedElement.value?.background ? SURFACE_EDITOR_COLOR_PANEL_MODES.bgFill : SURFACE_EDITOR_COLOR_PANEL_MODES.shapeFill
      }
    });
  }

  function setFill(selectedFill) {
    const fill = (() => {
      switch (selectedFill.type) {
        case SURFACE_EDITOR_FILL_TYPES.solid:
          return {
            type: SURFACE_EDITOR_FILL_TYPES.solid,
            color: selectedFill.color
          };
        case SURFACE_EDITOR_FILL_TYPES.linearGradient:
          return {
            type: SURFACE_EDITOR_FILL_TYPES.linearGradient,
            angle: selectedFill.angle,
            stops: selectedFill.stops
          };
        case SURFACE_EDITOR_FILL_TYPES.imagePattern:
          return {
            type: SURFACE_EDITOR_FILL_TYPES.imagePattern,
            url: selectedFill.url,
            scale: 1
          };
      }
    })();

    surfaceEditorStore.updateElement({
      element: selectedElement.value,
      updates: {
        content: {
          fill
        }
      }
    });
  }

  onMounted(() => {
    openFillPanel();
  });

</script>
